import Vue from 'vue'
import Router from 'vue-router'
import PC from '../components/PC'
import H5 from '../components/H5'

import newPc from '../components/newPc.vue'


Vue.use(Router)
export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '*',
      component: PC
    },
    {
      path: '/pc',
      name: 'PC',
      component: PC
    },
    {
      path: '/newPc',
      component: newPc
    },
    {
      path: '/h5',
      name: 'H5',
      component: H5
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js